//----------- Idle Scheduling -------------//
export const scheduleOnIdle = (cb, fallbackDelay = 50) => {
  if (typeof window.requestIdleCallback === "function") {
    return window.requestIdleCallback(cb);
  }

  return window.setTimeout(cb, fallbackDelay);
};

//----------- Frame Scheduling -------------//
export const scheduleOnFrame = (cb, fallbackDelay = 0) => {
  if (typeof window.requestAnimationFrame === "function") {
    return window.requestAnimationFrame(cb);
  }

  return window.setTimeout(cb, fallbackDelay);
};

//----------- Post-Paint Scheduling -------------//
export const scheduleAfterFirstPaint = (cb) => {
  if (typeof window.requestAnimationFrame !== "function") {
    window.setTimeout(cb, 32);
    return;
  }

  window.requestAnimationFrame(() => window.requestAnimationFrame(cb));
};

export const waitForStableLayout = () =>
  new Promise((resolve) => {
    // Dynamic stylesheet swaps also use two frames; measure on the frame after they commit.
    scheduleAfterFirstPaint(() => scheduleOnFrame(resolve));
  });
